import { Outlet } from 'react-router-dom';

import { useSaveLandingParams } from '../model/useSaveLandingParams';

export const LandingParamsInterceptor = () => {
  useSaveLandingParams();
  return <Outlet />;
};
